
// export const checkCourseParticipation = (user, course) => {
//   const allParticipations = user.participants.map(participant => participant.courseParticipations);
//   return allParticipations.flat().find(item => item.course.courseId === course.courseId);
// };

export const checkCourseParticipation = (participant, course) => {
    return participant.courseParticipations.find(item => item.course.courseId === course.courseId);
};